<div class="signature-pad-container">
  <canvas 
    #canvas 
    class="signature-pad-canvas"
    [style.width.px]="options.canvasWidth"
    [style.height.px]="options.canvasHeight">
  </canvas>
</div>
